import { mailApiHeaders } from './mailApiHeaders';

export type SendGroupPassPurchaseEmailParams = {
  to: string;
  groupName: string;
  couponCode: string;
  quantity: number;
  /** ISO 8601 */
  activationPeriodStart: string;
  activationPeriodEnd: string;
  totalWon?: number;
};

export type SendGroupPassPurchaseEmailResult =
  | { ok: true; messageId?: string }
  | { ok: false; skipped?: boolean; error: string };

type ApiOk = { ok: true; messageId?: string };
type ApiErr = { ok: false; skipped?: boolean; code?: string; message?: string; error?: string };

function apiUrl(): string {
  const base = (process.env.REACT_APP_API_BASE as string | undefined)?.replace(/\/$/, '') ?? '';
  return base ? `${base}/api/send-group-pass-email` : '/api/send-group-pass-email';
}

/**
 * 그룹 이용권 구매 직후, 입력 이메일로 쿠폰 안내 메일 발송.
 * 동일 출처 `/api/send-group-pass-email` (Gmail SMTP / nodemailer).
 */
export async function sendGroupPassPurchaseEmail(
  params: SendGroupPassPurchaseEmailParams,
): Promise<SendGroupPassPurchaseEmailResult> {
  try {
    const res = await fetch(apiUrl(), {
      method: 'POST',
      headers: await mailApiHeaders(),
      body: JSON.stringify(params),
    });

    let data: ApiOk | ApiErr | null = null;
    try {
      data = (await res.json()) as ApiOk | ApiErr;
    } catch {
      data = null;
    }

    if (!data || typeof data !== 'object') {
      return {
        ok: false,
        skipped: !res.ok,
        error: res.ok ? 'EMPTY_RESPONSE' : `HTTP_${res.status}`,
      };
    }

    if ('ok' in data && data.ok === true) {
      return { ok: true, messageId: (data as ApiOk).messageId };
    }

    const err = data as ApiErr;
    if (err.skipped) {
      return {
        ok: false,
        skipped: true,
        error: err.message ?? err.code ?? err.error ?? 'SKIPPED',
      };
    }
    return { ok: false, error: err.error ?? err.message ?? 'SEND_FAILED' };
  } catch (e) {
    return {
      ok: false,
      skipped: true,
      error: e instanceof Error ? e.message : String(e),
    };
  }
}
